module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_vm._v("12")])], 1)], 1), _vm._v(" "), _vm._l((2), function(i) {
    return _c('v-flex', {
      key: ("6" + i),
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "dark": "",
        "color": "secondary"
      }
    }, [_c('v-card-text', {
      staticClass: "px-0"
    }, [_vm._v("6")])], 1)], 1)
  }), _vm._v(" "), _vm._l((3), function(i) {
    return _c('v-flex', {
      key: ("4" + i),
      attrs: {
        "xs4": ""
      }
    }, [_c('v-card', {
      attrs: {
        "dark": "",
        "color": "primary"
      }
    }, [_c('v-card-text', {
      staticClass: "px-0"
    }, [_vm._v("4")])], 1)], 1)
  }), _vm._v(" "), _vm._l((4), function(i) {
    return _c('v-flex', {
      key: ("3" + i),
      attrs: {
        "xs3": ""
      }
    }, [_c('v-card', {
      attrs: {
        "dark": "",
        "color": "secondary"
      }
    }, [_c('v-card-text', {
      staticClass: "px-0"
    }, [_vm._v("3")])], 1)], 1)
  }), _vm._v(" "), _vm._l((6), function(i) {
    return _c('v-flex', {
      key: ("2" + i),
      attrs: {
        "xs2": ""
      }
    }, [_c('v-card', {
      attrs: {
        "dark": "",
        "color": "primary"
      }
    }, [_c('v-card-text', {
      staticClass: "px-0"
    }, [_vm._v("2")])], 1)], 1)
  }), _vm._v(" "), _vm._l((12), function(i) {
    return _c('v-flex', {
      key: ("1" + i),
      attrs: {
        "xs1": ""
      }
    }, [_c('v-card', {
      attrs: {
        "dark": "",
        "color": "secondary"
      }
    }, [_c('v-card-text', {
      staticClass: "px-0"
    }, [_vm._v("1")])], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92ea79b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Profile.vue
// module id = 53
// module chunks = 1